export default "__VITE_ASSET__86af93e6__"